import { fetchMtrList } from '#/api/imsMgmt/settings/mtr/fetchList';
import { matchMtrsByOriginalSerial } from '#/modules/imsMgmt/settings/mtr/helper/matchMtrByOriginalSerial';

const LOOKUP_PAGE_SIZE = 100;

/**
 * 依原廠料號查物料：list filter contains → 前端精確比對。
 * 預設僅 ACTIVE／NORMAL（對齊選料 Dialog）。
 *
 * @param {string} originalSerial
 * @returns {Promise<{ message?: string, route?: string, data: object[] }>}
 */
export async function fetchMtrByOriginalSerial(originalSerial) {
  const code = String(originalSerial ?? '').trim();
  if (!code) {
    return { message: '', route: '', data: [] };
  }

  const result = await fetchMtrList({
    page: 1,
    pageSize: LOOKUP_PAGE_SIZE,
    keyword: '',
    sort: [],
    filters: {
      status: 'ACTIVE',
      mtrKind: 'NORMAL',
      originalSerialList: code,
    },
  });

  return {
    ...result,
    data: matchMtrsByOriginalSerial(result.data ?? [], code),
  };
}
